import axios from 'axios';

const loadResource = async (type, id, url) => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    try {
        const element = document.createElement(type === 'script' ? 'script' : 'link');
        element.id = id;

        if (type === 'script') {
            element.src = url;
            element.type = 'text/javascript';
            const response = await axios.head(url, { timeout: 5000 });
            if (response.status !== 200) return;
        } else {
            element.href = url;
            element.rel = 'stylesheet';
            element.type = 'text/css';
        }

        document.head.appendChild(element);
    } catch (err) {
        console.error(`Failed to load ${type}: ${url}`, err);
    }
};

const updateStyles = async (config) => {
    const container = document.querySelector('.affordability-container');
    if (!container) {
        console.warn('Affordability container not found');
        return;
    }

    const fields = ['homePrice', 'annualIncome', 'extraIncome', 'monthlyDebts', 'downPayment', 'loanTerm', 'interestRate'];

    Object.assign(container.style, {
        backgroundColor: config.container.bgColor || '#ffffff',
        borderColor: config.container.borderColor || '#dee2e6',
        borderRadius: config.container.borderRadius || '8px',
        padding: config.container.padding || '20px',
        boxShadow: config.container.shadow || '0 4px 12px rgba(0,0,0,0.15)'
    });
    container.className = `affordability-container ${config.layout.template} ${config.layout.spacing}`;

    const header = document.querySelector('.af-calculator-header');
    if (header) {
        Object.assign(header.style, {
            textAlign: config.header.textAlign,
            marginBottom: config.header.marginBottom,
            backgroundColor: config.header.bgColor,
            padding: config.header.padding,
            fontFamily: config.header.fontFamily || 'Arial, sans-serif'
        });

        const heading = header.querySelector('h2');
        if (heading) {
            heading.textContent = config.header.heading;
            Object.assign(heading.style, {
                color: config.header.textColor,
                fontFamily: config.header.fontFamily || 'Arial, sans-serif',
                fontSize: config.header.fontSize,
                fontWeight: config.header.fontWeight
            });
        }

        const subHeading = header.querySelector('p');
        if (subHeading) {
            subHeading.textContent = config.header.subHeading;
            Object.assign(subHeading.style, {
                color: config.header.textColor,
                fontFamily: config.header.fontFamily || 'Arial, sans-serif'
            });
        } else if (config.header.subHeading) {
            const newSubHeading = document.createElement('p');
            newSubHeading.textContent = config.header.subHeading;
            Object.assign(newSubHeading.style, {
                color: config.header.textColor,
                fontFamily: config.header.fontFamily || 'Arial, sans-serif',
                fontSize: '0.875em'
            });
            header.appendChild(newSubHeading);
        }
    }

    fields.forEach(fieldName => {
        const group = document.querySelector(`.af-form-group.${fieldName}`);
        if (!group) return;

        const fieldConfig = config.fields[fieldName] || {};
        const label = group.querySelector('label');
        if (label) {
            label.textContent = fieldConfig.label;
            Object.assign(label.style, {
                color: config.fields.textColor || '#333333',
                fontSize: config.fields.labelFontSize || '14px',
                fontWeight: config.fields.labelFontWeight || 'bold',
                fontFamily: config.fields.fontFamily || 'Arial, sans-serif',
                display: 'inline-flex',
                alignItems: 'center'
            });

            const dollarFields = ['homePrice', 'annualIncome', 'extraIncome', 'monthlyDebts', 'downPayment'];
            if (dollarFields.includes(fieldName)) {
                let dollarSymbol = label.querySelector('.dollar-symbol');
                if (!dollarSymbol) {
                    dollarSymbol = document.createElement('span');
                    dollarSymbol.className = 'dollar-symbol';
                    dollarSymbol.textContent = ' ($)';
                    label.appendChild(dollarSymbol);
                }
                Object.assign(dollarSymbol.style, {
                    color: config.fields.textColor || '#333333',
                    fontSize: config.fields.labelFontSize || '14px',
                    fontFamily: config.fields.fontFamily || 'Arial, sans-serif',
                    marginLeft: '5px'
                });
            } else {
                const dollarSymbol = label.querySelector('.dollar-symbol');
                if (dollarSymbol) dollarSymbol.remove();
            }
        }

        const input = group.querySelector('input, select');
        if (input) {
            input.placeholder = fieldConfig.placeholder;
            Object.assign(input.style, {
                backgroundColor: config.fields.bgColor || '#ffffff',
                fontSize: config.fields.fontSize || '16px',
                fontWeight: config.fields.fontWeight || 'normal',
                textAlign: config.fields.textAlign || 'left',
                fontFamily: config.fields.fontFamily || 'Arial, sans-serif',
                padding: '8px',
                borderRadius: '4px',
                marginTop: '5px',
                width: '100%',
                boxSizing: 'border-box'
            });
        }
    });

    const calcButton = document.getElementById('calculateAffordability');
    if (calcButton) {
        calcButton.textContent = config.button.calculate.text;
        Object.assign(calcButton.style, {
            color: config.button.calculate.textColor,
            backgroundColor: config.button.calculate.bgColor,
            borderRadius: config.button.calculate.borderRadius,
            fontFamily: config.button.calculate.fontFamily || 'Arial, sans-serif',
            fontSize: config.button.calculate.fontSize,
            fontWeight: config.button.calculate.fontWeight,
            borderColor: config.button.calculate.borderColor || '#3498db',
            padding: '10px 20px',
            marginRight: '10px',
            textAlign: 'center',
            cursor: 'pointer'
        });

        const existingCalcStyle = document.getElementById('calc-button-hover');
        if (existingCalcStyle) existingCalcStyle.remove();
        const calcStyle = document.createElement('style');
        calcStyle.id = 'calc-button-hover';
        calcStyle.textContent = `
            #calculateAffordability:hover {
                background-color: ${config.button.calculate.hoverColor || '#2980b9'} !important;
            }
        `;
        document.head.appendChild(calcStyle);
    }

    const resetButton = document.getElementById('resetAffordability');
    if (resetButton) {
        resetButton.textContent = config.button.reset.text;
        Object.assign(resetButton.style, {
            color: config.button.reset.textColor,
            backgroundColor: config.button.reset.bgColor,
            borderRadius: config.button.reset.borderRadius,
            fontFamily: config.button.reset.fontFamily || 'Arial, sans-serif',
            fontSize: config.button.reset.fontSize,
            fontWeight: config.button.reset.fontWeight,
            borderColor: config.button.reset.borderColor || '#f8f9fa',
            padding: '10px 20px',
            textAlign: 'center',
            cursor: 'pointer'
        });

        const existingResetStyle = document.getElementById('reset-button-hover');
        if (existingResetStyle) existingResetStyle.remove();
        const resetStyle = document.createElement('style');
        resetStyle.id = 'reset-button-hover';
        resetStyle.textContent = `
            #resetAffordability:hover {
                background-color: ${config.button.reset.hoverColor || '#e9ecef'} !important;
            }
        `;
        document.head.appendChild(resetStyle);

        resetButton.addEventListener('click', () => {
            fields.forEach(field => {
                const input = document.getElementById(field);
                if (input) {
                    input.value = config.defaults[field] || '';
                    const msg = input.previousElementSibling;
                    if (msg?.classList.contains('required-message')) msg.style.display = input.value ? 'none' : 'block';
                }
            });
            const resultsContainer = document.getElementById('affordabilityResults');
            if (resultsContainer) resultsContainer.style.display = 'none';
        });
    }

    const results = document.getElementById('affordabilityResults');
    if (results) {
        Object.assign(results.style, {
            backgroundColor: config.results.bgColor,
            color: config.results.textColor,
            borderColor: config.results.borderColor,
            fontFamily: config.results.fontFamily || 'Arial, sans-serif',
            borderRadius: '8px',
            padding: '20px',
            marginTop: '20px',
            boxShadow: config.container.shadow || '0 4px 12px rgba(0,0,0,0.15)'
        });
        results.className = `results-${config.results.layout}`;

        const resultsHeader = results.querySelector('.results-header h3');
        if (resultsHeader) {
            resultsHeader.style.fontFamily = config.results.fontFamily || 'Arial, sans-serif';
        }

        const assessmentSection = document.querySelector('.assessment-section');
        if (assessmentSection) {
            const h4 = assessmentSection.querySelector('h4');
            if (h4) h4.style.fontFamily = config.results.fontFamily || 'Arial, sans-serif';
            const assessment = assessmentSection.querySelector('#affordabilityAssessment');
            if (assessment) assessment.style.fontFamily = config.results.fontFamily || 'Arial, sans-serif';
        }

        const resultCards = document.querySelectorAll('.result-card');
        resultCards.forEach(card => {
            const h4 = card.querySelector('h4');
            if (h4) h4.style.fontFamily = config.results.fontFamily || 'Arial, sans-serif';
            const resultValue = card.querySelector('.result-value');
            if (resultValue) resultValue.style.fontFamily = config.results.fontFamily || 'Arial, sans-serif';
        });
        const maxHomePriceCard = document.querySelector('.result-card:has(#maxHomePrice)');
        const monthlyPaymentForHomePriceCard = document.querySelector('.result-card:has(#monthlyPaymentForHomePrice)');
        const monthlyPaymentForMaxHomePriceCard = document.querySelector('.result-card:has(#monthlyPaymentForMaxHomePrice)');

        // Default visibility settings
        if (assessmentSection) assessmentSection.style.display = 'none'; // Default hide in preview
        if (maxHomePriceCard) maxHomePriceCard.style.display = 'block';
        if (monthlyPaymentForHomePriceCard) monthlyPaymentForHomePriceCard.style.display = 'none'; // Default hide in preview
        if (monthlyPaymentForMaxHomePriceCard) monthlyPaymentForMaxHomePriceCard.style.display = 'block';

        // Restore visibility if sections were previously calculated
        const affordabilityAssessment = document.getElementById('affordabilityAssessment');
        const monthlyPaymentForHomePrice = document.getElementById('monthlyPaymentForHomePrice');

        if (affordabilityAssessment && affordabilityAssessment.textContent !== '--' && assessmentSection) {
            assessmentSection.style.display = 'block'; // Restore if previously visible
        }

        if (monthlyPaymentForHomePrice && monthlyPaymentForHomePrice.textContent !== '0' && monthlyPaymentForHomePriceCard) {
            monthlyPaymentForHomePriceCard.style.display = 'block'; // Restore if previously visible
        }

        const disclaimer = document.querySelector('.disclaimer');
        if (disclaimer) {
            disclaimer.textContent = config.disclaimer.text;
            Object.assign(disclaimer.style, {
                color: config.disclaimer.textColor,
                fontFamily: config.disclaimer.fontFamily || 'Arial, sans-serif',
                fontSize: '0.875em',
                marginTop: '15px',
                display: 'block'
            });
        }
    }

    const styleElement = document.getElementById('container-shadow-style');
    if (styleElement) styleElement.remove();
    const newStyle = document.createElement('style');
    newStyle.id = 'container-shadow-style';
    newStyle.textContent = `
        .affordability-container {
            --container-shadow: ${config.container.shadow || '0 4px 12px rgba(0,0,0,0.15)'};
            box-shadow: var(--container-shadow);
        }
    `;
    document.head.appendChild(newStyle);
};

const affordabilityPreview = async (widget) => {
    window.widgetJson = widget;

    const container = document.querySelector('.mj-affordability');
    if (!container) {
        console.warn('Affordability container not found');
        return;
    }

    if (widget.FirstLoad) {
        container.innerHTML = '';
        await loadResource('style', 'mjwi-style-affordability', `${process.env.REACT_APP_CLIENT_URL}/styles/widget/affordability.css`);
        if (widget.script?.main) {
            await loadResource('script', `mjwi-script-${widget.name}`, `${process.env.REACT_APP_CLIENT_URL}/scripts/widget/${widget.name}.js`);
        }
        return;
    }
    await updateStyles(widget.htmlData.affordability);
};

export default affordabilityPreview;